import React, {useState, useEffect} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

import { withRouter } from "react-router";

import {Copyright} from '../../../components';

import { useFormik } from 'formik';

import {confirmAccessCode, logoutUser, resendAccessCode} from '../../../services/auth.service';
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import {store} from "react-notifications-component";
import {DASHBOARD_REVISION, LOCAL_STORAGE_KEYS} from "../../../utils/constants";
import {useAuth} from "../../../context/auth";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import Helmet from "react-helmet";
import {useLocation} from "react-router-dom";
import {GET_APP_LOCALIZE_TEXT} from "../../../utils/dq_lc_service/lc_service";
import GDPRConsentDialog from "./GDPRConsentDialog.comp";
import PoweredbyDQ from '../../../assets/images/PoweredByDQ_Default.png'

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        width: '50%',
        border:'2px solid #fe696e',
        backgroundColor: "#fe696e",
        color: "#fff",
        '&:hover': {
            backgroundColor: "#fe696e",
        },
    },
}));

const ConfirmEmail = (props) => {

    const classes = useStyles();
    const [loading, setLoading] = useState(false);
    const [resendLinkEnable, setResendLinkEnable] = useState(false)

    const { setAuthToken, setAuthUser } = useAuth();

    const location = useLocation();
    const pageLc = location.pathname.split('/')[1];
    const [gdprOpen, setGdprOpen] = useState(() => {
        try {
            const dashboard_rev_no = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.dashboard_rev_no));
            return dashboard_rev_no === DASHBOARD_REVISION.R2;
        } catch {
            return false;
        }
    });

    useEffect( ()=> {
        // props.history.push('/login');
        setTimeout( () => {
            setResendLinkEnable(true);
        }, 9000)
    }, [] )

    const handleConsent = () => {
        setGdprOpen(false);
    };

    const formik = useFormik({
        initialValues: {
            ver_code: ''
        },
        onSubmit: async (values) => {
            setLoading(true);

            console.log('Form data => ', values);
            try {
                const result = await confirmAccessCode(values.ver_code);
                console.log('result.data -> ', result.data);

                if (result.data && result.data.user) {
                    setAuthUser(result.data.user)
                    const c_user = result.data.user;
                    c_user.org_obj = result.data.org_object;
                    await setAuthUser(c_user);
                }

                store.addNotification({
                    title: GET_APP_LOCALIZE_TEXT(pageLc, "auth__confirmed"),
                    message: GET_APP_LOCALIZE_TEXT(pageLc, "auth__confirmed_email"),
                    type: "success",
                    insert: "bottom",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 2000,
                        showIcon: true
                    }
                });
                // redirect to login page here
                props.history.push('/home');
            } catch (e) {
                // already toasted the error
            }

            setLoading(false)
        }
    });

    const handleLogout = async () => {
        try {
            await logoutUser();
            setAuthToken(null);
            setAuthUser(null);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.auth_token);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.auth_user);
            localStorage.removeItem(LOCAL_STORAGE_KEYS.refresh_token);
            // history.push('/login');
        } catch (e) {
            // already toasted the error
        }
    };

    const resendVerificationCode = async () => {

        setLoading(true);

        try {
            const result = await resendAccessCode();
            console.log('result.data -> ', result.data);

            store.addNotification({
                title: GET_APP_LOCALIZE_TEXT(pageLc, "auth__resent_code"),
                message: GET_APP_LOCALIZE_TEXT(pageLc, "auth__resend_code_success"),
                type: "success",
                insert: "bottom",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 2000,
                    showIcon: true
                }
            });
        }
        catch (e) {
            // already toasted the error
        }

        setLoading(false);
    }

    return (
        <div>
            <Helmet title={`DQ-PRO | ${GET_APP_LOCALIZE_TEXT(pageLc, "auth__activate_acc")}`}/>
            <CssBaseline />
            <div className={classes.paper} style={{
                paddingBottom: '50px',
            }}>
                <img src={PoweredbyDQ} alt="Image"
                     style={{
                         width: '250px',
                         cursor: 'pointer',
                         marginBottom:'26px',
                     }}/>
            {!gdprOpen && (
             <>
                <Typography component="h1" variant="h5">
                    {GET_APP_LOCALIZE_TEXT(pageLc, "auth__enter_access_code")}
                </Typography>
                <Typography >
                    {GET_APP_LOCALIZE_TEXT(pageLc, "auth__check_email_code")}
                </Typography>
                <form className={classes.form} noValidate onSubmit={formik.handleSubmit}>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="ver_code"
                        label={GET_APP_LOCALIZE_TEXT(pageLc, "auth__access_code")}
                        name="ver_code"
                        autoComplete="ver_code"
                        autoFocus
                        onChange={formik.handleChange}
                        value={formik.values.ver_code}
                    />
                    <Typography align='center'>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        className={classes.submit}
                    >
                        {GET_APP_LOCALIZE_TEXT(pageLc, "general__submit")}
                    </Button>
                    </Typography>
                    <Grid container>
                        <Grid item xs>
                            <Link onClick={handleLogout} variant="body2">
                                {GET_APP_LOCALIZE_TEXT(pageLc, "auth__logout")}
                            </Link>
                        </Grid>
                        {
                            resendLinkEnable && <Grid item>
                                <Link onClick={resendVerificationCode} variant="body2">
                                    {GET_APP_LOCALIZE_TEXT(pageLc, "auth__resend_code")}
                                </Link>
                            </Grid>
                        }
                    </Grid>

                </form>
                    <Box mt={8}>
                        <Copyright />
                    </Box>
            </>
            )}

            <GDPRConsentDialog
                open={gdprOpen}
                onConsent={handleConsent}
            />
            <LoaderWithBackDrop loading={loading} />
            </div>
        </div>
    );
}

export default withRouter(ConfirmEmail);